<template>
    <div class="v-spa-animated-success-icon" :style="cssVars">
        <div class="trophy">
            <svg width="100%" height="100%" viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Group-2">
                        <circle id="circle" cx="250" cy="250" r="250"></circle>
                        <g id="icon" transform="translate(113.000000, 150.000000)">
                            <path d="M79.8700577,194.679455 L4.91673888,119.726136 C-0.941125497,113.868272 -0.941125497,104.370797 4.91673888,98.512933 C10.7746033,92.6550686 20.2720779,92.6550686 26.1299423,98.512933 L90.7013406,163.084293 L248.539105,5.24769132 C254.39697,-0.610173055 263.894444,-0.610173055 269.752309,5.24769132 C275.610173,11.1055557 275.610173,20.6030304 269.752309,26.4608948 L101.460895,194.752309 C97.756657,198.456546 92.5970474,199.818399 87.8226832,198.837865 L87.7787467,198.82962 C84.8816894,198.302615 82.1098294,196.919227 79.8700577,194.679455 Z" id="Combined-Shape"></path>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div class="confetti"></div>
        <div class="confetti two"></div>
        <div class="confetti three"></div>
        <div class="confetti four"></div>
        <div class="confetti--purple"></div>
        <div class="confetti--purple two"></div>
        <div class="confetti--purple three"></div>
        <div class="confetti--purple four"></div>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: Number,
                default: 180
            },
            shadowColor: {
                type: String,
                default: '40, 185, 136'
            },
            shadowColorMaxOpacity: {
                type: String,
                default: '0.45'
            },
            shadowSize: {
                type: Number,
                default: 15
            },
            backgroundColor: {
                type: String,
                default: '#26b887'
            },
            iconColor: {
                type: String,
                default: '#FFF'
            },
            confettiHeight: {
                type: Number,
                default: 50
            },
            confettiWidth: {
                type: Number,
                default: 10
            },
            confettiPrimaryColor: {
                type: String,
                default: '#26b887'
            },
            confettiSecondaryColor: {
                type: String,
                default: 'rgba(38, 184, 135, 0.2)'
            }
        },
        computed: {
            cssVars () {
                return{
                    '--size': `${this.size}px`,
                    '--shadow-color': this.shadowColor,
                    '--shadow-color-max-opacity': this.shadowColorMaxOpacity,
                    '--shadow-size': `${this.shadowSize}px`,
                    '--background-color': this.backgroundColor,
                    '--icon-color': this.iconColor,
                    '--confetti-height': `${this.confettiHeight}px`,
                    '--confetti-width': `${this.confettiWidth}px`,
                    '--confetti-primary-color': this.confettiPrimaryColor,
                    '--confetti-secondary-color': this.confettiSecondaryColor,
                }
            }
        }
    }
</script>


<style scoped lang="scss">
    @keyframes pulse {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(var(--shadow-color), 0);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 var(--shadow-size) rgba(var(--shadow-color), var(--shadow-color-max-opacity));
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(var(--shadow-color), 0);
        }
    }

    @keyframes trophy {
        0% {
            transform: translateY(500px);
            opacity: 0;
        }
        35% {
            opacity: 0;
        }
        100% {
            transform: translateY(0px);
            opacity: 1;
        }
    }

    @keyframes fly--up {
        0% {
            transform: translateY(10px);
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        40% {
            transform: translateY(-20vw);
        }
        60%, 100% {
            transform: translateY(-25vw);
            opacity: 0;
        }
    }

    @keyframes fly--down {
        0% {
            transform: translateY(-10px);
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        40% {
            transform: translateY(20vw);
        }
        60%, 100% {
            transform: translateY(25vw);
            opacity: 0;
        }
    }

    @keyframes fly--left {
        0% {
            transform: translateX(10px);
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        40% {
            transform: translateX(-35vw);
        }
        60%, 100% {
            transform: translateX(-50vw);
            opacity: 0;
        }
    }

    @keyframes fly--right {
        0% {
            transform: translateX(-10px);
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        40% {
            transform: translateX(35vw);
        }
        60%, 100% {
            transform: translateX(50vw);
            opacity: 0;
        }
    }

    @keyframes fly--up--left {
        0% {
            transform: rotate(135deg) translate(0vw,0vw);
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        60%, 100% {
            transform: rotate(135deg) translate(-3vw,20vw);
            opacity: 0;
        }
    }

    @keyframes fly--up--right {
        0% {
            transform: rotate(45deg);
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        60%, 100% {
            transform: rotate(45deg) translate(-3vw,-20vw);
            opacity: 0;
        }
    }

    @keyframes fly--down--left {
        0% {
            transform: rotate(45deg) translate(0vw,0vw);
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        60%, 100% {
            transform: rotate(45deg) translate(-3vw,20vw);
            opacity: 0;
        }
    }

    @keyframes fly--down--right {
        0% {
            transform: rotate(135deg) translate(0vw,0vw);
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        60%, 100% {
            transform: rotate(135deg) translate(0vw,-20vw);
            opacity: 0;
        }
    }

    .trophy {
        z-index: 1;
        height: 100%;
        width: 100%;
        border-radius: 100%;
        box-shadow: 0 0 0 0 rgba(var(--shadow-color), 1);
        animation: trophy 0.5s 1 forwards,
            pulse 2s infinite;

        svg #circle {
            fill: var(--background-color)
        }
        svg #icon {
            fill: var(--icon-color)
        }
    }

    .v-spa-animated-success-icon {
        height: var(--size);
        width: var(--size);
        position: relative;

        %confetti {
            z-index: -1;
            position: absolute;
            height: var(--confetti-height);
            width: var(--confetti-width);
            border-radius: var(--confetti-width);
            animation-fill-mode: forwards;
            animation-duration: 1.5s;
            animation-iteration-count: 3;
            transform-origin: center middle;
            opacity: 0;
        }

        .confetti {
            @extend %confetti;
            top: 0;
            left: calc(50% - calc(var(--confetti-width) / 2));
            background-color: var(--confetti-primary-color);
            animation-name: fly--up;
            animation-delay: 0.35s;

            &.two {
                top: auto;
                bottom: 0;
                animation-name: fly--down;
            }
            
            &.three,&.four {
                top: calc(50% - calc(var(--confetti-width) / 2));
                left: calc(50% - calc(var(--confetti-height) / 2));
                height: var(--confetti-width);
                width: var(--confetti-height);
                animation-name: fly--left;
            }
            
            &.four {			
                animation-name: fly--right;
            }

            &--purple {
                @extend %confetti;
                background-color: var(--confetti-secondary-color);
                animation-name: fly--up--left;
                transform: rotate(135deg);
                animation-delay: .5s;
                left: 20%;
                top: 20%;

                &.two {
                    animation-name: fly--up--right;
                    left: auto;
                    right: 20%;
                    transform: rotate(45deg);
                }

                &.three {
                    top: auto;
                    bottom: 20%;
                    transform: rotate(45deg);
                    animation-name: fly--down--left;
                }
                
                &.four {
                    top: auto;
                    bottom: 20%;
                    left: auto;
                    right: 20%;
                    transform: rotate(135deg);
                    animation-name: fly--down--right;
                }
            }
        }
    }
</style>